import React, { useState, useEffect } from 'react';
import Chat from './Chat';
import '../../styles/ChatbotWidget.css';
import WhatsAppIcon from '../../assets/icons/whatsapp-modern.svg';

export default function ChatBotWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  // Efeito para adicionar/remover scroll quando o chat está aberto no mobile
  useEffect(() => {
    if (isOpen && window.innerWidth <= 480) {
      // Previne scroll da página quando o chat está aberto no mobile
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Cleanup ao desmontar
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Simula notificação de nova mensagem (opcional)
  useEffect(() => {
    if (!isOpen) {
      const timer = setTimeout(() => {
        setHasNewMessage(true);
      }, 5000); // Mostra indicador após 5 segundos

      return () => clearTimeout(timer);
    } else {
      setHasNewMessage(false);
    }
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(true);
    setHasNewMessage(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="chatbot-widget">
      {isOpen && (
        <div className="chatbot-window">
          <button
            className="chatbot-close-btn"
            onClick={handleClose}
            aria-label="Fechar chat"
          >
            ✕
          </button>
          <Chat />
        </div>
      )}

      {!isOpen && (
        <button
          className="chatbot-toggle"
          onClick={handleToggle}
          aria-label="Abrir chat"
        >
          <img src={WhatsAppIcon} alt="WhatsApp" className="whatsapp-icon" />
          {hasNewMessage && (
            <span className="notification-badge">1</span>
          )}
        </button>
      )}
    </div>
  );
}